import { cn } from '@nesso/ui/lib/utils';

import type { TreatmentApproaches } from '@/entities/practice-member';
import { treatmentApproachesOptions } from '@/entities/treatment-approach';
import { SearchableCheckboxList } from '@/shared/ui/common/searchable-checkbox-list';
import { SelectedBadgeList } from '@/shared/ui/common/selected-badge-list';

import { MAX_APPROACHES, MIN_APPROACHES } from '../../config/notes-settings-options';

type Props = {
    draft: TreatmentApproaches;
    onChange: (next: TreatmentApproaches) => void;
    fill?: boolean;
};

export function TreatmentApproachesPicker({ draft, onChange, fill = false }: Props) {
    const chips = (
        <SelectedBadgeList
            options={treatmentApproachesOptions}
            selected={draft}
            onRemove={(approach) =>
                onChange(draft.filter((a) => a !== approach) as TreatmentApproaches)
            }
            disabled={draft.length <= MIN_APPROACHES}
            className={fill ? 'pl-2' : 'items-center py-1'}
            badgeClassName={fill ? undefined : 'gap-0 px-1 py-[2px] text-[13px] leading-[13px]'}
            labelClassName={fill ? undefined : 'px-1.5'}
        />
    );

    return (
        <div className={cn('flex flex-col', fill ? 'gap-8 flex-1 min-h-0' : 'gap-0')}>
            {fill ? chips : <div className="flex min-h-[54px] items-center px-2">{chips}</div>}
            <SearchableCheckboxList
                options={treatmentApproachesOptions}
                selected={draft}
                onChange={(selected) => onChange(selected as TreatmentApproaches)}
                minSelected={MIN_APPROACHES}
                maxSelected={MAX_APPROACHES}
                notFoundMessage="No approaches found"
                className={fill ? 'gap-4 flex-1 min-h-0' : 'gap-0'}
                inputWrapperClassName={
                    fill
                        ? undefined
                        : // 11px, not 12: the border's 1px counts toward the inset here, and
                          // Figma's stroke does not.
                          'border-input h-10 my-4 px-[11px] [&_input]:h-full'
                }
                commandListClassName={fill ? 'max-h-none' : 'flex-none max-h-[381px] pr-4'}
            />
        </div>
    );
}
